import { render, staticRenderFns } from "./product.vue?vue&type=template&id=15a85685&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=15a85685&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a85685",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a85685')) {
      api.createRecord('15a85685', component.options)
    } else {
      api.reload('15a85685', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=15a85685&scoped=true", function () {
      api.rerender('15a85685', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contract/customerManage/contractFrom/product.vue"
export default component.exports